module.exports = "/assets/blank.png?atUj9bZ";